import { ContractorType, Agents } from "../../../pages/contractor/type";
import agentApiService from "../../../services/contractor/agentApiService";
import { NewContractorRequest } from "../../../types/contractor/NewContractor";

export const newContractor = async (state: ContractorType) => {
  const data = agentApiService.createContractor(state);
  return data;
};

const createAgentRequest = (brokers: Agents) =>
  brokers.map(({ agentCode, agentCommision, basePremiumCP14, basePremiumNCP26, businessType }) => ({
    agentCode,
    agentCommision,
    basePremiumCP14,
    basePremiumNCP26,
    businessType,
  }));

export const createContractorRequest = (state: ContractorType): NewContractorRequest => {
  return {
    companyName: state.companyName,
    UENNo: state.uenNumber,
    address: {
      postalCode: state.postalCode,
      number: state.number,
      streetName: state.streetName,
      floorNumber: state.floorNumber,
      unitNumber: state.unitNumber,
    },
    sumInsured: state.sumInsured,
    agents: createAgentRequest(state.agents),
    directors: state.directors,
    guarantors: state.guarantors,
  };
};
